import { cacheFirstConfig, http } from '@/core/helpers/http.helper';
import { ApiResource } from '@/core/models/api-resource.interface';
import { LocationQuery } from 'vue-router';
import { CommunicationDirectionType } from './communication-direction-type.interface';
export class CommunicationDirectionsTypeService {
   async getCommunicationDirectionsTypes(query: LocationQuery) {
      const response = await http.get<ApiResource<Array<CommunicationDirectionType>>>('/communication-direction-types', {
         ...cacheFirstConfig,
         params: { ...query },
      });
      return response.data;
   }

   async getCommunicationDirectionsType() {
      throw Error('Method not implemented');
   }

   async postCommunicationDirectionsType() {
      throw Error('Method not implemented');
   }

   async putCommunicationDirectionsType() {
      throw Error('Method not implemented');
   }

   async deleteCommunicationDirectionsType() {
      throw Error('Method not implemented');
   }
}
